module.exports = __webpack_public_path__ + "3990401e0d344268c449e40ac3840ea6.svg";